import React, { useEffect, useMemo, useRef } from 'react';
import { Animated, Platform, Text, View } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import {
  SQUAD_TV_EXIT_HINT_FADE_MS,
  SQUAD_TV_MODE_COPY,
  SQUAD_TV_MODE_TEST_IDS,
} from '../../../src/worldcup/constants/squadTvMode.constants';
import { getSquadTvExitHintStyles } from './SquadTvExitHint.styles';

interface SquadTvExitHintProps {
  visible: boolean;
}

export const SquadTvExitHint: React.FC<SquadTvExitHintProps> = ({ visible }) => {
  const theme = useTheme();
  const styles = useMemo(() => getSquadTvExitHintStyles(theme), [theme]);
  const opacity = useRef(new Animated.Value(visible ? 1 : 0)).current;

  useEffect(() => {
    if (visible) {
      opacity.setValue(1);
      return;
    }

    Animated.timing(opacity, {
      toValue: 0,
      duration: SQUAD_TV_EXIT_HINT_FADE_MS,
      useNativeDriver: true,
    }).start();
  }, [visible, opacity]);

  return (
    <Animated.View
      style={[styles.root, { opacity }]}
      pointerEvents="none"
      testID={SQUAD_TV_MODE_TEST_IDS.exitHint}
    >
      <View style={styles.chip}>
        <Text style={styles.hintText}>{SQUAD_TV_MODE_COPY.EXIT_TV_DOUBLE_TAP_HINT}</Text>
        {Platform.OS === 'web' ? (
          <Text style={styles.escapeText}>{SQUAD_TV_MODE_COPY.EXIT_TV_ESCAPE_HINT}</Text>
        ) : null}
      </View>
    </Animated.View>
  );
};
